var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7708 26.25H18.2292M8.75 10.2083C8.75 7.45792 8.75 6.08417 9.60458 5.22958C10.4592 4.375 11.8329 4.375 14.5833 4.375H20.4167C23.1671 4.375 24.5408 4.375 25.3954 5.22958C26.25 6.08417 26.25 7.45792 26.25 10.2083V24.7917C26.25 27.5421 26.25 28.9158 25.3954 29.7704C24.5408 30.625 23.1671 30.625 20.4167 30.625H14.5833C11.8329 30.625 10.4592 30.625 9.60458 29.7704C8.75 28.9158 8.75 27.5421 8.75 24.7917V10.2083Z",
    stroke: "#F58320",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.8333e067bfc00abe506c86da1a0ea49f.svg";
export { ForwardRef as ReactComponent };